// extracted by mini-css-extract-plugin
export var container = "_r1-0";
export var dotAnimation = "_r1-2";
export var dotsLoading = "_r1-1";